export enum TipoProfessorModuloTCC {
  Orientador = 'Orientador',
  Banca = 'Banca'
}
